<div class="loading-indicator_overlay"></div>
<div class="loading-indicator_animation_wrapper">
    <div class="loading-indicator_animation">
        <svg class="loading-indicator_icon">
            <use xlink:href="#circle"></use>
        </svg>
    </div>
</div>
